export default "__VITE_ASSET__48922052__"